import { NiInput } from '@component/ant-component';
import * as React from 'react';
import { CommentPayload, TextGenerator } from '..';
import { GenerationLevel, GenerationTag, GenerationTextType } from '@config/text-generator';

export default function ({ commentPayload, onCommentChange, onCodeSelected }: {
  commentPayload: CommentPayload;
  onCommentChange: (next: string) => void;
  onCodeSelected: (code: string) => void;
}) {

  return <></>;

  // return <NiInput
  //   style={{ marginBottom: 8 }}
  //   key={commentPayload.comment}
  //   placeholder="Enter comment"
  //   defaultValue={commentPayload.comment}
  //   onBlur={(e: any) => {
  //     if (onCommentChange) {
  //       onCommentChange(e.target.value);
  //     }
  //   }}
  //   addonAfter={<TextGenerator
  //     level={getLevel()}
  //     type={GenerationTextType.Code}
  //     tag={GenerationTag.Code}
  //     commentPayload={commentPayload}
  //     onSelect={(value: string) => {
  //       onCodeSelected(value);
  //     }}

  //   />}
  // />;
}

function getLevel() {
  return window.location.pathname.includes('/slot/') ? GenerationLevel.Slot : GenerationLevel.Type;
}
